import { render, staticRenderFns } from "./newContent.vue?vue&type=template&id=907372fe&scoped=true"
import script from "./newContent.vue?vue&type=script&lang=js"
export * from "./newContent.vue?vue&type=script&lang=js"
import style0 from "./newContent.vue?vue&type=style&index=0&id=907372fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "907372fe",
  null
  
)

export default component.exports